import { TablePaginationFilter } from "@/models/table.model";
import { SearchProductFiltersAPI } from "../models/product";
import { SearchCustomerFilters } from "../models/customer";

function getFiltersParameters({
	filters
}: {
	filters: SearchCustomerFilters | SearchProductFiltersAPI | TablePaginationFilter;
}): Record<string, string | number | boolean> {
	const queryFilterd = Object.entries(filters).filter(([, value]) => {
		if (typeof value === "string") {
			if (value === "all") return false;

			return value.length > 0;
		}
		return true;
	});

	return Object.fromEntries(queryFilterd);
}

export const HttpUtil = {
	getFiltersParameters
};
